<template>
    <div class="vue-qr-code-wrapper">
        <vue-qrcode :value="url" :width="140"  :margin="0"></vue-qrcode>
    </div>
</template>

<script>
import VueQrcode from 'vue-qrcode'

export default {
    props: {
        url: {
            type: String
        }
    },

    components: {
        VueQrcode,
    },
}
</script>